<template>
    <div>
        <f-read-only-field
            v-if   = "readonly"
            class  = "w-100 mt-1"
            :dense = "true"
            :label = "label"
            :value = "name"
            color  = "pt-0-5 pl-1 ro-background"
        />

        <f-enum-select
            v-if          = "!readonly"
            v-model       = "objValue"
            :label        = "label"
            :readonly     = "readonly"
            module        = "msd"
            type          = "escGadgetRentType"
            :hide-details = "hideDetails"
            @input        = "onChange"
        />
    </div>
</template>

<script>
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField.vue";
import FEnumSelect    from "@/modules/core/components/utils/FEnumSelect.vue";

export default {
    name: "FEnumSelectRw",
    components: {
        FEnumSelect,
        FReadOnlyField
    },

    props: {
        value: {
            required: true
        },

        label: {
            required: true,
        },

        module: {
            type: String,
            required: true,
        },

        type: {
            type: String,
            required: true,
        },

        readonly: {
            type: Boolean,
            required: false,
            default: function () {
                return false;
            }
        },

        hideDetails: {
            type: Boolean,
            required: false,
            default: function () {
                return false;
            },
        },
    },

    data: () => ({
        objValue: true,
    }),

    computed: {
        name () {
            if (!this.objValue) {
                return null;
            }

            const enums = this.$store.getters [this.module][this.type];
            const value = enums.find(e => e.id === this.objValue.id);
            if (!value) {
                return null;
            }

            return value.name;
        }
    },

    mounted() {
        this.objValue = this.value;
    },

    watch: {
        value () {
            this.objValue = this.value;
        }
    },

    methods: {
        onChange () {
            this.$emit("input", this.objValue);
        }
    }
}
</script>

<style scoped>

</style>